import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { style: {"min-width":"700px","width":"60vw","margin":"auto","margin-top":"20px"} }
const _hoisted_3 = { class: "fg-color-blue" }
const _hoisted_4 = {
  key: 0,
  class: "badge badge-info ml-2"
}
const _hoisted_5 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_6 = {
  key: 1,
  class: "alert alert-warning",
  role: "alert"
}
const _hoisted_7 = {
  key: 2,
  class: "border-box"
}
const _hoisted_8 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = {
  key: 0,
  style: {"text-decoration":"line-through"},
  class: "text-muted"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "col-2" }
const _hoisted_14 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_15 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_16 = {
  key: 2,
  class: "badge badge-success"
}
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = { class: "col-3" }
const _hoisted_19 = {
  key: 0,
  class: "input-group input-group-sm"
}
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_22 = { class: "col-1" }
const _hoisted_23 = ["onClick"]

import { computed, onMounted, watch, ref } from 'vue'
    import { guid } from '@common/Guid'
    import { copyToClipboard } from '@common/Common'
    import { useRouter, useRoute } from 'vue-router'
    import { useMyAccessTokensPage } from '@Organizations/AccessTokens/pages-core'
    import { useUserQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import AdminNavigationV2 from "@common/AdminNavigationV2.vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageUserAccessTokensPage',
  setup(__props) {

    document.title = "Manage Access Tokens"

    const router = useRouter()
    const route = useRoute()

    const id = ref()
    const secret = ref()
    const copied = ref(false)

    // Get user ID from route parameter
    const targetUserId = computed(() => route.params.id as string)

    const {
        useCurrentUserQuery,
        useUserAccessTokensQuery,
        useGenerateAccessTokenCommand,
        useRevokeAccessTokenCommand,
    } = useMyAccessTokensPage()

    const accessToken = computed(() => btoa(`${id.value}/${secret.value}`))

    // Get current admin user info
    const { modelCurrentUserQueryV1: currentUserModel, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const organizationUnitId = computed(() => currentUserModel.value?.OrganizationUnitId)

    // Get target user info (the service account we're managing)
    const { modelUserQueryV1, runUserQueryV1 } = useUserQueryV1(targetUserId)
    const targetUser = computed(() => modelUserQueryV1.value)

    // Get access tokens for the target user
    const { modelUserAccessTokensQueryV1, runUserAccessTokensQueryV1, succeed: succeedUserAccessTokensQueryV1 } = useUserAccessTokensQuery(targetUserId)
    const accessTokens = computed(() => modelUserAccessTokensQueryV1.value?.AccessTokens || [])

    const { invokeGenerateAccessTokenCommandV1, succeedGenerateAccessTokenCommandV1 } = useGenerateAccessTokenCommand(id, organizationUnitId, targetUserId, secret)

    const { invokeRevokeAccessTokenCommandV1, succeedRevokeAccessTokenCommandV1 } = useRevokeAccessTokenCommand(null, targetUserId)

    onMounted(() => {
        runCurrentUserQueryV1()
        if (targetUserId.value) {
            runUserQueryV1()
            runUserAccessTokensQueryV1()
        }
    })

    watch(targetUserId, () => {
        if (targetUserId.value) {
            runUserQueryV1()
            runUserAccessTokensQueryV1()
        }
    })

    watch(succeedGenerateAccessTokenCommandV1, () => runUserAccessTokensQueryV1())
    watch(succeedRevokeAccessTokenCommandV1, () => runUserAccessTokensQueryV1())

    function handleGenerateAccessTokenCommandV1() {
        id.value = guid()
        secret.value = `${guid()}${guid()}`.replace(/-/g, '')
        invokeGenerateAccessTokenCommandV1()
    }

    function handleRevokeAccessTokenCommandV1(token) {
        if (confirm(`Do you really want to revoke access token "${token.Name}"? This action cannot be undone.`)){
            invokeRevokeAccessTokenCommandV1({id: token.Id})
        }
    }

    function handleCopyToClipboard() {
        copyToClipboard(accessToken.value)
        copied.value = true

        const h = setTimeout(() => {
            copied.value = false
            clearTimeout(h)
        }, 2000)
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (organizationUnitId.value)
        ? (_openBlock(), _createBlock(AdminNavigationV2, {
            key: 0,
            tid: organizationUnitId.value
          }, null, 8 /* PROPS */, ["tid"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1))),
      type: "button",
      class: "btn btn-lg btn-link",
      style: {"margin-left":"20px"}
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("i", {
        class: "fa fa-arrow-left",
        "aria-hidden": "true"
      }, null, -1 /* CACHED */),
      _createTextVNode(" Back to service account ", -1 /* CACHED */)
    ]))]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _cache[2] || (_cache[2] = _createTextVNode(" API Access Tokens ", -1 /* CACHED */)),
        (targetUser.value && targetUser.value.IsServiceUser)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Service Account"))
          : _createCommentVNode("v-if", true)
      ]),
      (targetUser.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _cache[3] || (_cache[3] = _createTextVNode(" Managing access tokens for: ", -1 /* CACHED */)),
            _createElementVNode("strong", null, _toDisplayString(targetUser.value.DisplayName), 1 /* TEXT */),
            _createTextVNode(" (" + _toDisplayString(targetUser.value.Email) + ") ", 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _cache[12] || (_cache[12] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
      _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      (targetUser.value && !targetUser.value.IsServiceUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", {
              class: "fa fa-exclamation-triangle",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createElementVNode("strong", null, "Warning:", -1 /* CACHED */),
            _createTextVNode(" This account is not a service account. Access tokens should primarily be used for service accounts. ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_unref(succeedUserAccessTokensQueryV1) && targetUser.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[10] || (_cache[10] = _createElementVNode("div", {
              class: "alert alert-info mb-4",
              role: "alert"
            }, [
              _createElementVNode("i", {
                class: "fa fa-info-circle",
                "aria-hidden": "true"
              }),
              _createElementVNode("strong", null, "About API Access Tokens:"),
              _createTextVNode(" These tokens are used for API authentication and should be kept secure. They expire after 180 days and can be revoked at any time. "),
              _createElementVNode("br"),
              _createElementVNode("br"),
              _createElementVNode("strong", null, "Important:"),
              _createTextVNode(" The full token is only shown once when generated. Make sure to copy it immediately. ")
            ], -1 /* CACHED */)),
            (accessTokens.value.length==0)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_8, "No access tokens generated"))
              : _createCommentVNode("v-if", true),
            (accessTokens.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"row font-weight-bold mb-2\" data-v-86d1bef2><div class=\"col-3\" data-v-86d1bef2><strong data-v-86d1bef2>Name</strong></div><div class=\"col-2\" data-v-86d1bef2><strong data-v-86d1bef2>Status</strong></div><div class=\"col-3\" data-v-86d1bef2><strong data-v-86d1bef2>Expiration</strong></div><div class=\"col-3\" data-v-86d1bef2><strong data-v-86d1bef2>Token</strong></div><div class=\"col-1\" data-v-86d1bef2><strong data-v-86d1bef2>Actions</strong></div></div><hr data-v-86d1bef2>", 2)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accessTokens.value, (token) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: token.Id,
                      class: "row mb-2 align-items-center"
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        (token.IsExpired || token.IsRevoked)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(token.Name), 1 /* TEXT */))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(token.Name), 1 /* TEXT */))
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        (token.IsRevoked)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Revoked"))
                          : (token.IsExpired)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Expired"))
                            : (_openBlock(), _createElementBlock("span", _hoisted_16, "Active"))
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("small", {
                          class: _normalizeClass({'text-danger': token.IsExpired})
                        }, _toDisplayString(token.ExpireAt), 3 /* TEXT, CLASS */)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        (token.Id==id.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("input", {
                                value: copied.value ? 'COPIED!' : accessToken.value,
                                type: "text",
                                class: _normalizeClass(["form-control bg-white", {'text-success': copied.value}]),
                                readonly: ""
                              }, null, 10 /* CLASS, PROPS */, _hoisted_20),
                              _createElementVNode("div", { class: "input-group-append" }, [
                                _createElementVNode("button", {
                                  onClick: handleCopyToClipboard,
                                  class: "btn btn-outline-secondary",
                                  type: "button",
                                  title: "Copy to clipboard"
                                }, [...(_cache[5] || (_cache[5] = [
                                  _createElementVNode("span", { class: "fa fa-copy" }, null, -1 /* CACHED */)
                                ]))])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, [...(_cache[6] || (_cache[6] = [
                              _createElementVNode("i", { class: "fa fa-lock" }, null, -1 /* CACHED */),
                              _createTextVNode(" Hidden ", -1 /* CACHED */)
                            ]))]))
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        (!token.IsRevoked && !token.IsExpired)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: ($event: any) => (handleRevokeAccessTokenCommandV1(token)),
                              class: "btn btn-sm btn-danger",
                              type: "button",
                              title: "Revoke access token"
                            }, [...(_cache[7] || (_cache[7] = [
                              _createElementVNode("i", { class: "fa-solid fa-ban" }, null, -1 /* CACHED */)
                            ]))], 8 /* PROPS */, _hoisted_23))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true),
            _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: handleGenerateAccessTokenCommandV1
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("i", {
                class: "fa fa-key",
                "aria-hidden": "true"
              }, null, -1 /* CACHED */),
              _createTextVNode(" Generate new access token ", -1 /* CACHED */)
            ]))])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})